module.exports = __webpack_public_path__ + "static/media/info.a5fe4b0b.svg";